export default __webpack_public_path__ + "static/media/11.9f401c85.mp3";